import dynamic from 'next/dynamic';
const ServiceOverview = dynamic(() => import('./ServiceOverview'));
export default ServiceOverview;
